import { DropdownFilterButton } from '@finbeat/react-toolkit';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useUserWorkplaceState } from 'components/Workplaces/Users/Users';
import { useTranslation } from 'react-i18next';

type MerchantOrderAddButtonProps = {
    showModal: () => void;
};

const MerchantOrderAddButton = ({ showModal }: MerchantOrderAddButtonProps) => {
    const { t } = useTranslation();
    const { setSelectedItem: setCurrentItem } = useUserWorkplaceState();

    return (
        <DropdownFilterButton
            onClick={() => {
                setCurrentItem(null);
                showModal();
            }}
            icon={faPlus}
            disabled={false}
            title="BackOfficeOrderAdd"
            text={t('BackOfficeOrderAdd')}
        />
    );
};

export default MerchantOrderAddButton;
